
import { apiAuthList, apiGetHeader } from "@/api/shop";
import { Component, Prop, Vue } from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import { RequestPaging } from "@/utils/util";
@Component({
    components: {
        lsPagination,
    },
})
export default class ShopList extends Vue {
    /** S Data **/

    apiAuthList = apiAuthList;

    pager: RequestPaging = new RequestPaging();

    searchObj = {
        type: "",
    };

    typeList: any = [];

    /** E Data **/
    /** S Methods **/
    // 获取提现配置

    //
    getShopLists(): void {
        this.pager.request({
            callback: apiAuthList,
            params: {
                ...this.searchObj,
            },
        });
    }

    // 重置搜索
    reset(): void {
        Object.keys(this.searchObj).map((key) => {
            this.$set(this.searchObj, key, "");
        });
        this.getShopLists();
    }

    getTypeList() {
        apiGetHeader({}).then((res) => {
            this.typeList = res.find(
                (item: any) => item.field == "type"
            ).options;
        });
    }

    /** E Methods **/

    /** S ods **/
    created() {
        this.getTypeList();
        this.getShopLists();
    }
}
